var map = {
	"./academic-paper.svg": "d566",
	"./add-docadd-doc.svg": "9d71",
	"./applepay.svg": "fcc4",
	"./blue-tick.svg": "71d8",
	"./cert.svg": "30e8",
	"./delete-icon.svg": "c1b2",
	"./discover.svg": "3478",
	"./duplicate-icon.svg": "28f1",
	"./gpay.svg": "1107",
	"./green-tick.svg": "f6d1",
	"./image-upload-logo.svg": "0bb4",
	"./invoice.svg": "30a3",
	"./logo.svg": "e347",
	"./logo_no_name.svg": "04df",
	"./lp-cert-1.svg": "9fc1",
	"./lp-invoice.svg": "8a5a",
	"./lp-memo-1.svg": "68e9",
	"./lp-report-1.svg": "3b26",
	"./lp-report-2.svg": "8622",
	"./lp-report-3.svg": "c82a",
	"./macbook-header.svg": "adcb",
	"./mastercard.svg": "2dac",
	"./memo.svg": "d30d",
	"./orange-star.svg": "ef98",
	"./orange-tick.svg": "1026",
	"./paypal.svg": "b67a",
	"./pro-price-logo.svg": "5bf4",
	"./purple-tick.svg": "17f7",
	"./remix-icons-fill-design-Vector.svg": "5f3d",
	"./remix-icons-fill-design.svg": "03ab",
	"./report.svg": "3c8a",
	"./stripe.svg": "1e1a",
	"./visa.svg": "f73a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";